import { MatesRideDialogComponent } from './../../dialogs/mates-ride-dialog/mates-ride-dialog.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { query } from '@angular/animations';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-search-ride',
  templateUrl: './search-ride.component.html',
  styleUrls: ['./search-ride.component.scss'],
})
export class SearchRideComponent implements OnInit {
  pickupLoc: any;
  dropoffLoc: any;
  travelDate: any;

  constructor(
    public dialog: MatDialog,
    public router: Router,
    private titleService: Title,
    private meta: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      `Car pool and Ride Sharing Solution in and from Canberra, Melbourne, Sydney, Brisbane, Perth, Adelaide and all over Australia  - Matesride helps connect autoscoop user for Car Pooling and Ride Share`
    );
    this.meta.updateTag({
      name: 'keywords',
      content:
        'Get a Ride, Car pool, Ride Sharing , Canberra to Melbourne, Canberra to Sydney, Melbourne to Canberra, Sydney to Canberra, Sydney to Melbourne, Melbourne to Sydney, Travel, Earn Money, Save Money',
    });
    this.meta.updateTag({
      name: 'description',
      content:
        'A simple and useful action to reduce CO2 emissions, Traffic congestion, Stress & Fatigue by sharing short and long distances Carpool/Ride Shares which also saves you on Travel Cost!',
    });
  }

  searchFlag() {
    return this.pickupLoc && this.dropoffLoc && this.travelDate;
  }
  openDialog(flag: any): void {
    console.log('opening');
    const dialogRef = this.dialog.open(MatesRideDialogComponent, {
      width: '600px',
      data: { flag },
    });

    dialogRef.afterClosed().subscribe(result => {
      const resultarr = Object.keys(result);
      if (resultarr.includes('pickup')) {
        this.pickupLoc = result.pickup;
      } else if (resultarr.includes('dropoff')) {
        this.dropoffLoc = result.dropoff;
      } else {
        this.travelDate = result.date;
      }
      console.log('The dialog was closed', result);
    });
  }

  searchRides() {
    // tslint:disable-next-line:max-line-length
    const queryObj = {
      from: this.pickupLoc || '',
      to: this.dropoffLoc || '',
      date: this.travelDate || '',
      queryFlag: true,
    };
    this.router.navigate(['/ride/viewAll']);
  }
}
